var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"id":_vm.id,"value":_vm.value,"formatter":_vm.formatter,"lazy-formatter":"","disabled":_vm.disabled,"state":_vm.validationState},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }